import { useThemeUI as useThemeUI$1 } from '@theme-ui/core';
import { EMPTY_THEME } from '../themes/const.esm.js';
import { isEmptyObject } from '../utils/assertion.esm.js';

function useSafeThemeUI(props) {
  var _useBaseThemeUI = useThemeUI$1(),
    theme = _useBaseThemeUI.theme;
  if (isEmptyObject(theme)) {
    return (props === null || props === void 0 ? void 0 : props.theme) || EMPTY_THEME;
  }
  return theme;
}
function useThemeUI () {
  return useThemeUI$1();
}

export default useThemeUI;
export { useSafeThemeUI };
//# sourceMappingURL=use-theme-ui.esm.js.map
